export default "__VITE_ASSET__D73P3Tev__"